export const budget = {
    // Títulos de header do Stack (app/budget/_layout.tsx). `detail` pertence à
    // tela detail/[id] (outra área), mas o título mora no _layout — fica aqui.
    screens: {
        index: 'Orçamento',
        form: 'Orçamento',
        detail: 'Detalhe do Orçamento',
        history: 'Histórico',
    },
    // Meta de receita = orçamento type='income' (ADR 0046) — um conceito só,
    // o tipo é escolhido dentro do form.
    incomeTarget: {
        section: 'Metas de receita',
    },
    list: {
        emptyTitle: 'Nenhum orçamento',
        emptySubtitle: 'Defina limites por categoria para acompanhar o que já foi gasto no mês.',
        emptyAction: 'Criar orçamento',
        byCategory: 'Por categoria',
        // Divisor quando há metas de receita acima dos tetos de gasto.
        spendingSection: 'Gastos',
    },
    summary: {
        budgeted: 'Orçado',
        spent: 'Gasto',
        overLimit_one: '{{count}} categoria acima do limite',
        overLimit_other: '{{count}} categorias acima do limite',
        // Variante das Metas de receita (mesmo card, kind='income').
        target: 'Meta',
        received: 'Recebido',
        incomeToGo: 'Faltam {{amount}} para a meta',
        incomeReached: 'Meta batida',
    },
    card: {
        progress: '{{spent}} / {{amount}}',
        // O sufixo só aparece com 2+ categorias; o _one existe pela regra de
        // plural do i18next e nunca renderiza hoje.
        progressWithCategories_one: '{{spent}} / {{amount}} · {{count}} categoria',
        progressWithCategories_other: '{{spent}} / {{amount}} · {{count}} categorias',
        overBudget: 'excedido',
        remaining: 'restante',
        // Variante meta de receita (type='income'): encher a barra é conquista.
        goalReached: 'meta batida',
        toGo: 'faltam',
        // Chip da origem no card (ADR 0103). Contagem exibida, não plural gramatical.
        originsCount: '{{originCount}} origens',
        // Chip do recorte por subcategoria (ADR 0110), mesmo molde.
        subcategoriesCount: '{{subcategoryCount}} subcategorias',
    },
    form: {
        titleNew: 'Novo Orçamento',
        titleEdit: 'Editar Orçamento',
        amountLabel: 'Valor do orçamento',
        amountLabelIncome: 'Meta mensal de receita',
        typeLabel: 'Tipo',
        type: {
            expense: 'Despesa',
            income: 'Receita',
        },
        typeIncomeHint: 'Meta de receita: as entradas das categorias escolhidas contam sozinhas no progresso (ex: repasses da Uber e da 99).',
        nameLabel: 'Nome',
        namePlaceholder: 'Ex: Essenciais',
        categoriesLabel: 'Categorias',
        categoriesSelected_one: '{{count}} selecionada',
        categoriesSelected_other: '{{count}} selecionadas',
        categoriesPlaceholder: 'Selecionar categorias...',
        colorLabel: 'Cor',
        iconLabel: 'Ícone',
        // Ciclo do orçamento (ADR 0120): cadência + âncora. `periodLabel` fica pra
        // compatibilidade de chave; a tela usa `cycleLabel`.
        periodLabel: 'Período',
        cycleLabel: 'Ciclo',
        period: {
            monthly: 'Mensal',
            biweekly: 'Quinzenal',
            weekly: 'Semanal',
        },
        cycleStartDayLabel: 'Começa no dia',
        cycleStartDayCalendar: 'Dia 1 (mês inteiro)',
        cycleStartDayValue: 'Dia {{day}}',
        cycleStartDaySheetTitle: 'Dia de início',
        cycleStartDayHint: 'O ciclo vai desse dia até a véspera dele no mês seguinte. Pra seguir a fatura do cartão, use o dia do fechamento + 1; pra seguir o salário ou o vale, o dia em que ele cai.',
        cycleWeekdayLabel: 'A semana começa na',
        cycleAnchorLabel: 'Quinzena de referência',
        cycleAnchorHint: 'As outras quinzenas contam de 14 em 14 dias a partir dessa data, pra frente e pra trás.',
        cyclePreview: 'Ciclo em curso: {{range}}.',
        // Recorte por origem (ADR 0103). O placeholder DIZ o padrão em vez de ficar
        // vazio: recorte vazio significa todas as origens, e calar isso faria a linha
        // parecer não-configurada quando na verdade ela está no estado clássico.
        originsLabel: 'Onde',
        originsPlaceholder: 'Todas as contas e cartões',
        // Contagem exibida, não plural gramatical — placeholder próprio de propósito.
        originsSummary: '{{name}} e mais {{extra}}',
        // Subcategorias (ADR 0110): quem conta (recorte) + limites (ADR 0067), só em despesa.
        // O resumo é "Só Energético · 1 limite"; sem nada configurado, "Todas · sem limites".
        subcategoriesLabel: 'Subcategorias',
        subcategoriesAll: 'Todas',
        subcategoriesOnly: 'Só {{name}}',
        // Contagem exibida, não plural gramatical — placeholder próprio de propósito.
        subcategoriesOnlyMore: 'Só {{name}} e mais {{extra}}',
        subcategoriesNoLimits: 'sem limites',
        subcategoriesLimits_one: '{{count}} limite',
        subcategoriesLimits_other: '{{count}} limites',
        subcategoryLimitsOverflow: 'Seus limites passam o teto em {{amount}}',
        deleteButton: 'Excluir orçamento',
        saveA11yCreate: 'Criar orçamento',
        saveA11ySave: 'Salvar',
        colorSheetTitle: 'Escolha uma cor',
        iconSheetTitle: 'Escolha um ícone',
    },
    deleteDialog: {
        title: 'Excluir orçamento',
        message: 'Tem certeza? O orçamento será removido, mas as transações serão mantidas.',
        confirm: 'Excluir',
    },
    // Sheet do recorte por origem (ADR 0103). Vazio = TODAS as origens, que é o
    // orçamento clássico — por isso o rodapé confirma mesmo sem nada marcado.
    originsSheet: {
        title: 'Onde esse orçamento vale',
        subtitle: 'Opcional. Sem escolher nada, ele vale em todas as contas e cartões.',
        searchPlaceholder: 'Buscar conta ou cartão...',
        accounts: 'Contas',
        cards: 'Cartões',
        all: 'Todas as contas e cartões',
        confirm: 'Confirmar',
        clear: 'Limpar seleção',
        archived: 'Arquivado',
    },
    categoriesSheet: {
        title: 'Categorias do orçamento',
        // A categoria NÃO é bloqueada (ADR 0109): pode estar em quantos orçamentos a
        // pessoa quiser. O aviso da linha é só informativo.
        subtitle: 'Escolha uma ou mais. A mesma categoria pode estar em mais de um orçamento.',
        searchPlaceholder: 'Buscar categoria...',
        alreadyUsed: 'Já usada em outro orçamento',
        // Contagem exibida, não plural gramatical — placeholder próprio de
        // propósito ({{count}} dispararia a resolução de plural do i18next).
        confirm: 'Confirmar ({{selectedCount}})',
        selectAtLeastOne: 'Selecione ao menos uma',
    },
    // Sheet de subcategorias (ADR 0110): a caixa diz se ENTRA no orçamento, o campo diz o
    // limite (ADR 0067). "Demais lançamentos" é o envelope residual CALCULADO — nunca
    // digitado —, por isso o valor dele é só exibido.
    subcategoriesSheet: {
        title: 'Subcategorias',
        subtitle: 'Desmarque o que não entra no orçamento. Se quiser, reserve um limite por linha. Ao menos uma fica marcada por categoria.',
        includeA11y: 'Incluir {{name}} no orçamento',
        excludeA11y: 'Tirar {{name}} do orçamento',
        reserved: '{{amount}} reservados',
        free: '{{amount}} livres',
        setLimit: 'Definir limite',
        residual: 'Demais lançamentos',
        residualHint: 'Calculado automaticamente',
        empty: 'As categorias escolhidas não têm subcategorias.',
        confirm: 'Confirmar',
        clearA11y: 'Remover limite de {{name}}',
        // Estouro é estado previsto (ADR 0141): a frase diz o quanto passou e o botão
        // diz o número que o orçamento vai passar a ter — nunca "corrigir"/"ajustar" sozinho.
        overflow: 'Seus limites passam o valor do orçamento em {{amount}}',
        useSum: 'Usar a soma: {{amount}}',
        useSumA11y: 'Definir o valor do orçamento como {{amount}}, a soma dos limites',
    },
    // Tela app/budget/detail/[id].tsx. `detail.budgeted` é literal próprio — não
    // confundir com `summary.budgeted` (card de resumo da lista). `detail.exceeded`/`detail.remaining` são capitalizados (colunas
    // do card), distintos de `card.overBudget`/`card.remaining` (minúsculos).
    detail: {
        // O sufixo só aparece com 2+ categorias; o _one existe pela regra de plural
        // do i18next e nunca renderiza hoje.
        categoriesCount_one: '{{count}} categoria',
        categoriesCount_other: '{{count}} categorias',
        budgeted: 'Orçado',
        exceeded: 'Excedido',
        remaining: 'Restante',
        editBudget: 'Editar orçamento',
        // Contagem exibida no título, não plural gramatical — placeholder próprio de
        // propósito ({{count}} dispararia a resolução de plural do i18next).
        transactionsTitle: 'Transações ({{transactionCount}})',
        emptyTransactions: 'Nenhuma transação neste período',
        // Acompanhamento do recorte por subcategoria (ADR 0067).
        limitsTitle: 'Limites por subcategoria',
        limitsOverflow: 'Seus limites passam o teto em {{amount}}',
        overLimitBy: '{{amount}} acima do limite',
        residual: 'Demais lançamentos',
        // Contagem exibida, não plural gramatical — placeholder próprio de propósito
        // ({{count}} dispararia a resolução de plural do i18next).
        residualAndMore: '{{names}} e mais {{extra}}',
    },
    // Retrospecto (tela app/budget/history.tsx + card do detalhe). Contagens exibidas em
    // placeholders próprios ({{count}} dispararia a resolução de plural do i18next), e as
    // frases da cadência são chaves INTEIRAS porque o gênero muda junto com o substantivo
    // ("Últimos 6 meses" × "Últimas 6 semanas") — {{unit}} não fecha em português.
    history: {
        // Rótulo do 6m/12m no header. Contagem exibida, não plural gramatical.
        range: '{{months}}m',
        averageOf: 'Média · {{range}}',
        ofCap: 'do teto',
        withinCap: 'Dentro do teto',
        ofMonths: 'de {{monthCount}} meses',
        noClosedCycles: 'Nenhum ciclo fechou ainda. O retrospecto começa quando o primeiro ciclo do seu orçamento encerra.',
        emptyTitle: 'Sem histórico',
        emptySubtitle: 'Crie um teto de gasto para acompanhar quantos meses fecham dentro dele.',
        // Acertos sobre ciclos julgados ("4/6"). Contagens exibidas, não plural gramatical.
        score: '{{within}}/{{judged}}',
        chipA11y: '{{budget}} em {{month}}',
        legendWithin: 'dentro',
        legendOver: 'estourou',
        // Antes de o orçamento existir não havia teto: o ciclo aparece, mas sem veredito.
        legendUntracked: 'sem orçamento',
        legendOpen: 'ciclo em curso, até {{date}}',
        detailTitleMonthly: 'Últimos {{cycleCount}} meses',
        detailTitleBiweekly: 'Últimas {{cycleCount}} quinzenas',
        detailTitleWeekly: 'Últimas {{cycleCount}} semanas',
        averageAndCap: 'média {{average}} · teto {{cap}}',
        capOnly: 'teto {{cap}}',
        overrunMonthly: 'Estourou em {{overCount}} dos últimos {{judgedCount}} meses fechados.',
        overrunBiweekly: 'Estourou em {{overCount}} das últimas {{judgedCount}} quinzenas fechadas.',
        overrunWeekly: 'Estourou em {{overCount}} das últimas {{judgedCount}} semanas fechadas.',
        suggestion: 'Um teto de {{amount}} cobriria a sua média.',
        adjust: 'Ajustar',
    },
};
